var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "supsis-button",
      class:
        ((_obj = {}),
        (_obj[_vm.classNames] = true),
        (_obj.disabled = _vm.disabled),
        (_obj.primary = _vm.primary),
        (_obj.danger = _vm.danger),
        (_obj.ghost = _vm.ghost),
        (_obj.small = _vm.small),
        (_obj.large = _vm.large),
        (_obj.xlarge = _vm.xlarge),
        _obj),
      on: { click: _vm.click },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }